import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAttachment } from '../../attachments/models/attachments.model';

@Component({
  selector: 'app-comment-attachments-dialog',
  templateUrl: './comment-attachments-dialog.component.html',
  styleUrls: ['./comment-attachments-dialog.component.scss'],
  standalone: false,
})
export class CommentAttachmentsDialogComponent {
  control = new FormControl<IAttachment[]>([], { nonNullable: true });

  constructor(
    public dialogRef: MatDialogRef<CommentAttachmentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { attachments: IAttachment[] }
  ) {
    this.control.setValue(this.data.attachments);
  }
}
